let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4hQ2L")).then(() => parcelRequire('fqDvU'));